export const environment = {
  name: 'dev',
  production: false,
  appBaseHref: '/',
  genesysCloud: {
    clientId: 'c2076938-baf4-4991-8c99-def20227b658', // Use the same client Id used for know-client orchestrators l2c
  },
  videoUrl: 'https://dev.assets.genesyscsdteng.com/assets/videos/gc_welcome_background.mp4',
  api: {
    kepler: {
      slapfive: {
        apiKey: 'Tg3qMpp4o74eMM1wBxXs7LSURm3DSXf8v2k7vf8i',
        url: 'https://kepler-slapfive-api.genesyscsdteng.com/dev',
      },
    },
  },
  orchestrator: {
    baseUrl: 'https://orchestrators.genesyscsdteng.com',
  },
  featureFlags: {
    limitedRegionView: false,
  },
};
